import { useEffect } from 'react';
import { useAppDispatch } from '../../../app/hooks';

import { DisplayPopUpTypes, PopUpRequestObject } from '../../../interfaces';
import './CalculatorButton.scss';
import { fetchPopUpResult } from '../../../features/filter/filterSlice';

type CommonProps = {
  title: string;
  isOpen: boolean;
};

type ConditionlProps =
  | {
      onOpen?: () => void;
      popupType?: DisplayPopUpTypes;
      popUpRequest?: PopUpRequestObject;
      url?: never;
    }
  | {
      onOpen?: never;
      popupType?: never;
      popUpRequest?: never;
      url?: string;
    };

type Props = CommonProps & ConditionlProps;

const CalculatorButton = ({ onOpen, title, url, popupType, popUpRequest, isOpen }: Props) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (popupType && popUpRequest && isOpen) {
      const popUpResultFilter = async () =>
        await dispatch(fetchPopUpResult({ motionType: popupType, popUpFilters: popUpRequest }));

      popUpResultFilter();
    }
  }, [dispatch, isOpen, popUpRequest, popupType]);

  return url ? (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={url}
      className="fwe-color-caerul fwe-bg-gray-100 calculator--button"
    >
      <i className="fwe-icon fwe-icon-calculator "></i>
      <span className="calculator-button__text">{title}</span>
    </a>
  ) : (
    <button className="fwe-color-caerul fwe-bg-gray-100 calculator--button" onClick={onOpen}>
      <i className="fwe-icon fwe-icon-calculator "></i>
      <span className="calculator-button__text">{title}</span>
    </button>
  );
};

export default CalculatorButton;
